export const CALENDARLIST_TOPIC = 'calendarList/'



// WEBPACK FOOTER //
// ./src/features/realTimeClient/topics.js